export { CreateTenderDetailsComponent } from './create-tender-details.component';
